import * as React from 'react';
import { cn } from '@/lib/utils';

export type WfBadgeVariant = 'neutral' | 'accent' | 'success' | 'amber' | 'danger' | 'violet';

export interface WfBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: WfBadgeVariant;
}

/** Badge pill mono do wireframe (.b + receitas de cor). */
export const WfBadge = React.forwardRef<HTMLSpanElement, WfBadgeProps>(
  ({ variant = 'neutral', className, children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn('wf-badge', variant !== 'neutral' && `wf-badge-${variant}`, className)}
      {...props}
    >
      {children}
    </span>
  )
);
WfBadge.displayName = 'WfBadge';
